<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div>
    <v-overlay

    ></v-overlay>

    <v-navigation-drawer
        absolute class="drawer"
        permanent
        right
        width="900"
    >
      <v-content class="view">
        <!--<v-card>-->
        <v-btn class="btn-previous d-none d-md-inline" color="primary" fab fixed left outlined small
               top
               @click="previous()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn class="btn-next d-none d-md-inline" color="primary" fab fixed outlined right small
               top
               @click="next()">
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>


        <v-container v-if="activeTab==='Info'" fluid>
          <v-row>
            <v-col style="padding-left: 72px;padding-bottom: 0">

              <v-btn :loading="toggle_start_loading" class="mr-4" style="min-width: 20px;padding:0;position: relative"
                     text @click="ToggleStar()">
                <v-icon v-if="customer.stars && customer.stars.length >0" class="yellow--text"
                        large
                        style="position: absolute;top:0;left:0">
                  mdi-star
                </v-icon>
                <v-icon large>
                  mdi-star-outline
                </v-icon>
              </v-btn>

              {{ current_customer.nickname }}<br/>
              <TypeBadge :type="current_customer.type"></TypeBadge>
              {{ current_customer.code }}

            </v-col>
            <v-col class="d-none d-md-inline" style="padding-right: 72px;padding-bottom: 0">
              <div v-if="
                  current_customer.status == CustomerConst.STATUS_SUBMITTED_PENDING_SYNC ||
                  current_customer.status == CustomerConst.STATUS_SYNCED_PENDING_ACTIVE
                " class="headline text-right">
                สถานะลูกค้า: รออนุมัติ
              </div>

              <CreditBar v-else
                         :current="customer.debit_amount"
                         :fontSize="32"
                         :height="72"
                         :max="customer.credit_amount?customer.credit_amount:0"
                         :prop_blue="customer.debit_pending"
                         :prop_green="customer.debit_invoice"
                         :prop_red="customer.debit_overdue"
                         :width="400"
              ></CreditBar>

            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div>
                <!--<v-card-title class="headline">-->

                <!--</v-card-title>-->
                {{ current_customer.name }}
              </div>
              <div>
                ที่อยู่: {{ customer.address }}<br/>
                {{ customer.district }}
                {{ customer.province }}
                {{ customer.zip_code }}<br/>
                <!--tax: {{customer.tax_no}}<br/>-->
                <!--email: {{customer.erp_email}}-->
              </div>
              <div class="title">โทร: {{ customer.erp_contract }} <a
                  :href="'tel:+66'+customer.erp_tel">{{ customer.erp_tel }}</a>
              </div>
            </v-col>
            <v-col class="text-right">
              <div>
                วงเงิน: ใช้แล้ว {{ customer.debit_amount }} บาท จาก {{ customer.credit_amount }} บาท<br/>
                <span v-if="customer.debit_pending>0">ค้างส่ง {{ customer.debit_pending }} บาท <br/></span>
                <span v-if="customer.debit_invoice>0" class="red--text">ค้างชำระ {{ customer.debit_invoice }} บาท <br/></span>

                เครดิต: {{ customer.credit_term }} วัน<br/>
                ธุรกิจ: {{ customer.business_type }}<br/>
                กลุ่มราคา: {{ customer.price_group ? PromotionGroupConst.map(customer.price_group.price_group) : '-' }}

              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
              <v-card class="pa-2">
                <span class="caption float-right">
<!--                  <v-btn :loading="google_isLoad" x-small @click="searchLocation()">ค้น google</v-btn>-->
                  <v-btn :loading="google_isLoad" class="ml-1" x-small @click="editLocation()">แก้ไข</v-btn></span>
                <span class="caption">แผนที่
                <span v-if="customer.gis_type===CustomerConst.GIS_TYPE_NONE">(ยังไม่ยืนยัน)</span>
                  <span v-if="customer.gis_type===CustomerConst.GIS_TYPE_DISTRICT">(ตำบล)</span>
                  <span v-if="customer.gis_type===CustomerConst.GIS_TYPE_GOOGLE">(จาก google)</span>
                  <span v-if="customer.gis_type===CustomerConst.GIS_TYPE_USER">(ปักแล้ว)</span>
                </span>
                <v-divider class="mt-2"></v-divider>
                <!--                customer.cache_lat>0?`https://maps.googleapis.com/maps/api/staticmap?center=${customer.cache_lat},${customer.cache_lng}&zoom=12&size=400x400&key=AIzaSyC1O0kuADUz8RR8oIsUhR26GEG0CIT_oiI`: -->
                <a :href="customer.cache_lat>0?`https://maps.google.com/?q=${customer.cache_lat},${customer.cache_lng}`:'#'"
                   :target="customer.cache_lat>0?'_blank':'_self'">
                  <v-img
                      :src="`https://maps.googleapis.com/maps/api/staticmap?center=${customer.district}+${customer.province}&size=320x180&key=AIzaSyC1O0kuADUz8RR8oIsUhR26GEG0CIT_oiI${customer.cache_lat>0?'&markers=size:small%7Ccolor:red%7Clabel:X%7C'+customer.cache_lat+','+customer.cache_lng+'':'&zoom=12'}`"
                      aspect-ratio="1.6"
                      class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                          align="center"
                          class="fill-height ma-0"
                          justify="center"
                      >
                        <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                        <!--GIS: {{customer.gis_lat}},{{customer.gis_lng}} <br/>-->

                      </v-row>
                    </template>
                  </v-img>
                </a>


                <!--                <iframe v-if="customer.cache_lat>0" width="100%" height="100%" style="border:0" loading="lazy"-->
                <!--                        allowfullscreen-->
                <!--                        :src="'https://www.google.com/maps/embed/v1/place?q='+customer.cache_lat+'%2C'+customer.cache_lng+'&key=AIzaSyC1O0kuADUz8RR8oIsUhR26GEG0CIT_oiI'"></iframe>-->
                <!--                <iframe v-else width="100%" height="100%" style="border:0" loading="lazy"-->
                <!--                        allowfullscreen-->
                <!--                        :src="'https://www.google.com/maps/embed/v1/place?q='+encodeURI(customer.name)+'+'+encodeURI(customer.address)+'+'+encodeURI(customer.district)+'+'+encodeURI(customer.province)+'&key=AIzaSyC1O0kuADUz8RR8oIsUhR26GEG0CIT_oiI'"></iframe>-->

                <v-checkbox v-if="customer"
                            :loading="confirmingLocation"
                            v-model="customer.gis_is_confirm"
                            class="mt-0 align-end"
                            hide-details
                            label="ยืนยัน"
                            @change="onConfirmLocation()"
                ></v-checkbox>

              </v-card>


            </v-col>
            <v-col>
              <v-card class="pa-2">
                <span class="caption">กราฟแสดงการสี่งซื้อ</span>
                <v-divider></v-divider>
                <v-sparkline
                    v-if="customer.id"
                    :auto-line-width="true"
                    :fill="false"
                    :gradient="['#42b3f4']"
                    :labels="graphData.labels"
                    :show-labels="true"
                    :smooth="false"
                    :value="graphData.values"
                    label-size="10"
                    type="bar"

                ></v-sparkline>

              </v-card>

            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-4">
              เซลล์
              <v-divider class="mb-2"></v-divider>
              <!--{{customer.cache_sales}}-->

              <Avatar v-for="sale in sales" v-bind:key="sale.id" :active="true" :user="sale"
                      @click.native="openSales()"></Avatar>
              <v-avatar
                  v-if="!sales || sales.length===0"
                  color="grey"
                  size="64px"
                  @click="openSales()"
              >
                <v-icon x-large>mdi-plus</v-icon>
              </v-avatar>

            </v-col>
            <v-col>

              <v-textarea
                  v-model="customer.erp_remark1"
                  class="mb-1"
                  height="86px"
                  hide-details
                  label="หมายเหตุ"
                  outlined
                  @keypress="isCommentChange=true"
              ></v-textarea>
              <v-row v-if="isCommentChange">

                <v-col>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn

                      :loading="isLoadSetComment"
                      class="primary float-right" tile
                      @click="setComment()">
                    บันทึก
                  </v-btn>
                </v-col>
              </v-row>
              <v-row
                  v-if="!isCommentChange && [
                  UserConst.ROLE_ADMIN,
                  UserConst.ROLE_CEO,
                  UserConst.ROLE_DIRECTOR,
                  UserConst.ROLE_MANAGER,
                  UserConst.ROLE_ACCOUNT,
                  UserConst.ROLE_MARKETING].includes($store.state.$user.role)
              && customer.status===CustomerConst.STATUS_SYNCED_PENDING_ACTIVE">
                <v-col>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="isLoadSetStatus" class="error" tile @click="RejectCustomer()">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="isLoadSetStatus" class="disabled" tile @click="ApproveCustomer()">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>

            </v-col>
          </v-row>


        </v-container>


        <v-container v-if="activeTab==='Order'" fluid>
          <v-row>
            <v-col style="padding-left: 72px;padding-bottom: 0">
              <v-icon class="mr-4" large>mdi-star-outline</v-icon>
              {{ current_customer.nickname }}<br/>
              <TypeBadge :type="customer.type"></TypeBadge>
              {{ customer.code }}
            </v-col>
            <v-col style="padding-right: 72px;padding-bottom: 0">
              <v-text-field class="search"
                            hide-details="true"
                            label="ค้นหา"
                            outlined
                            placeholder="ใส่คำค้นหา"
                            small
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>

              <div :style="{
                        paddingLeft:(8)+'px',
                        paddingRight:(8)+'px',

                     }"
                   class="list-header">
                <v-row
                    class="list-header-row">
                  <v-col>
                    <!--<v-btn outlined tile class="status-btn">รอ</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn amber">ส่ง</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn orange">บิล</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn red">เลย</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn grey">เสร็จ</v-btn>-->
                    <!--<v-btn outlined tile class="status-btn purple">ค้าง</v-btn>-->

                    <!--<v-btn v-if="false" v-for="{text,key,count} in filter.status.options" outlined tile-->
                    <!--:class="{-->
                    <!--'status-btn':true,-->
                    <!--'':key <= OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO,-->
                    <!--'amber':key === OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK || key === OrderConst.STATUS_ON_DELIVERY,-->
                    <!--'orange':key === OrderConst.STATUS_INVOICED,-->
                    <!--'green':key === OrderConst.STATUS_PAID,-->
                    <!--'red':key === OrderConst.STATUS_OVERDUE,-->
                    <!--'grey':key === OrderConst.STATUS_TRANSACTION_CLEAR,-->
                    <!--'purple':key === OrderConst.STATUS_TRANSACTION_UNCLEAR,-->
                    <!--}"-->
                    <!--&gt;-->
                    <!--{{text}} ({{count}})-->
                    <!--</v-btn>-->
                  </v-col>
                  <v-col class="text-right caption">

                    <v-btn
                        class="title"
                        ourlined tile @click="isPickingDate=!isPickingDate">
                      {{ dateFrom }} - {{ dateTo }}
                    </v-btn>
                    <br/>
                    ปุ่มลัด:
                    <a href="#" @click="setDateLastMonth()">เดือนก่อน</a> &nbsp;
                    <a href="#" @click="setDateThisMonth()">เดือนนี้</a> &nbsp;
                    <a class="" href="#" @click="setDateToday()">วันนี้</a>
                  </v-col>
                </v-row>
                <v-row v-if="isPickingDate"
                       class="list-header-row">

                  <v-col class="text-right">
                    <v-date-picker

                        v-model="dateFrom"
                        locale="th"
                    ></v-date-picker>
                    <v-date-picker

                        v-model="dateTo"
                        locale="th"
                    ></v-date-picker>
                  </v-col>
                </v-row>

              </div>


              <v-content>

                <v-container
                    v-if="orders && orders.length>0"
                    child-flex
                    class="fill-height container pb-12"
                    fluid
                >

                  <v-data-table
                      v-if="orders && Array.isArray(orders)"
                      :headers="[
                        {
                          text: 'วันที่',
                          value: 'created_at',
                        },
                        { text: 'เลขที่', value: 'code' },
                        { text: 'ยอด in.vat', value: 'total_net',align:  'end'},
                        { text: 'สถานะ', value: 'status' },
                      ]"
                      :items="orders"
                      :loading="this.tabs_order.isLoad"
                      class="elevation-1 tr-clickable"
                      @click:row="(item,debug)=>openOrder({order:item,orders:orders,debug:debug})"
                  >

                    <template v-slot:item.created_at="{ item }">
                      {{ parseDate(item.created_at) }}
                    </template>
                    <template v-slot:item.code="{ item }">
                      #{{ item.code }}
                    </template>

                    <template v-slot:item.total_net="{ item }">
                      {{ number_format(item.total_net) }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-btn :color="getStatusColor(item.status)" style="width:100%" tile>
                        {{ getStatusText(item.status) }}
                      </v-btn>
                    </template>
                  </v-data-table>

                </v-container>
              </v-content>


            </v-col>
          </v-row>

        </v-container>


        <v-content v-if="activeTab==='Checkin'">
          <v-card-title class="headline">Customer</v-card-title>
          <v-card-text>Checkin</v-card-text>

        </v-content>


        <v-app-bar bottom fixed height="60">
          <!--<v-footer bottom>-->
          <!--<template v-slot:default>-->
          <v-tabs
              bottom
              center-active

              centered
              fixed
              height="60"
              slider-color="slider"
              slider-size="5"
          >

            <TabForDialog v-for="(tab, index) in tabs" :key="index" :tab="tab"></TabForDialog>
          </v-tabs>
          <!--</template>-->
        </v-app-bar>

        <v-btn bottom class="close-button" color="primary" fab fixed float right
               @click="$store.commit('dialog_is_customer',{toggle:false})">
          <v-icon>mdi-close</v-icon>
        </v-btn>


        <!--</v-card>-->
        <!--</v-dialog>-->
      </v-content>
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>

.overlay {
  z-index: 5 !important;
}

.drawer {
  z-index: 6 !important;
}

.view {

  .v-card__title {
    padding-left: 68px;
    padding-right: 68px;
  }

  .v-app-bar {
    padding-right: 96px;
  }

  .list-row {
    position: relative;
    margin: 0;
  }

  .container {
    padding-top: 8px;
    width: 100%;
  }
}

.order-panel {
  margin-top: 1px;
  height: calc(100vh - 130px);
  position: relative;
  overflow: auto;

}

.btn-previous {

}

.btn-next {

}
</style>

<script lang="ts">

import {Customer, CustomerConst} from '@/models/Customer'
import {FilterOrder, Order, OrderConst} from '@/models/Order'
import {PromotionGroupConst} from '@/models/Promotion'
import {User, UserConst} from '@/models/User'
import {Component, Vue} from 'vue-property-decorator'
import CreditBar from '../components/Customer/CreditBar.vue'
import TypeBadge from '../components/Customer/TypeBadge.vue'
import OrderRowInCustomer from '../components/Order/OrderRowInCustomer.vue'
import TabForDialog from '../components/TabForDialog.vue'
import Avatar from '../components/User/Avatar.vue'
import router from '../router'
import Helper from '../services/Helper.js'
import ViewOrder from '../views/ViewOrder.vue'

@Component({
  components: {
    Avatar,
    TypeBadge,
    OrderRowInCustomer,
    TabForDialog,
    ViewOrder,
    CreditBar,
  },
})
export default class CustomerOldDialog extends Vue {
  activeTab: string = 'Info'
  CustomerConst = CustomerConst
  PromotionGroupConst = PromotionGroupConst
  tabs_info = {
    name: 'ข้อมูล',
    click: () => this.click_tab('Info'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_order = {
    name: 'ออร์เดอร์',
    click: () => this.click_tab('Order'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_checkin = {
    name: 'เช็คอิน',
    click: () => this.click_tab('Checkin'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
  }
  tabs_cart = {
    name: 'สั่งสินค้า',
    click: () => this.click_tab('Cart'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: true,
    badge_number: 5,
  }

  tabs = [
    this.tabs_info,
    this.tabs_order,
    // this.tabs_checkin,
    this.tabs_cart,
  ]

  dialog: boolean = false
  number_format = Helper.number_format
  isLoadCustomer = false
  isLoadOrders = false
  isLoadSetComment = false
  isCommentChange = false
  isLoadSetStatus = false
  UserConst = UserConst
  OrderConst = OrderConst
  isPickingDate = false
  dateFrom = new Date().toISOString().substr(0, 10)
  dateTo = new Date().toISOString().substr(0, 10)
  customer: Customer = new Customer()
  orders: Order[] | null = null
  graphData = {labels: [' ', ' '], values: [0, 0]}
  sales: User[] | null = null
  filter = new FilterOrder()
  google_isLoad = false
  stat_isLoad = false
  toggle_start_loading: boolean = false
  confirmingLocation: boolean = false

  get current_customer(): Customer {
    return this.$store.state.customers.data[this.$store.state.customers.current]
  }

  getStatusColor(status) {
    return this.OrderConst.color(status)
  }

  getStatusText(status) {
    return this.OrderConst.map(status)
  }

  parseDate(dateStr) {
    const date = new Date(Date.parse(dateStr))
    return date.toLocaleString('th-TH', {
      weekday: 'short',
      year: '2-digit',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })

    // .toLocaleDateString('th-TH', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
  }

  async click_tab(name: string): Promise<void> {

    if (name == 'Cart') {
      if (
          this.current_customer.status == CustomerConst.STATUS_SUBMITTED_PENDING_SYNC ||
          this.current_customer.status == CustomerConst.STATUS_SYNCED_PENDING_ACTIVE

      ) {
        // alert("ลูกค้าไม่สามารถสั่งสินค้าได้ รอส่วนกลางอนุมัติบัญชี");
        this.$root.$emit('onWarning', {message: 'ลูกค้าไม่สามารถสั่งสินค้าได้ รอส่วนกลางอนุมัติบัญชี'})
        return
      }

      if (
          this.current_customer.status == CustomerConst.STATUS_REJECTED) {
        this.$root.$emit('onWarning', {message: 'ลูกค้าสถานะไม่อนุมัติ ไม่สามารถสั่งสินค้าได้'})
        return
      }

      if (
          this.current_customer.status == CustomerConst.STATUS_NOT_USE) {
        this.$root.$emit('onWarning', {message: 'ลูกค้าสถานะไม่ใช้แล้ว ไม่สามารถสั่งสินค้าได้'})
        return
      }


      if (
          this.current_customer.business_type == '') {
        this.$root.$emit('onWarning', {message: 'ลูกค้าไม่มีกลุ่มธุรกิจ ติดต่อฝ่ายบัญชี'})
        return
      }

      this.tabs_cart.isLoad = true
      var order = await this.$store.dispatch('init_cart', this.current_customer)//.then((cart: Order) => {
      this.tabs_cart.isLoad = false
      this.$store.commit('dialog_is_customer', {toggle: false})
      router.push('/cart')
      // })
      return
    }

    this.activeTab = name

    switch (name) {
      case 'Info':
        this.onTabInfo()
        break
      case 'Order':
        this.onTabOrder()
        break
      case 'Checkin':
        this.onTabCheckin()
        break
    }

  }

  mounted() {
    console.log('customer dialog mounted')

    let tmpDateFrom = new Date()
    tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 3)
    this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)

    this.onTabInfo()
    this.reloadCart()
  }

  previous() {
    this.$store.commit('customer_current', -1)
    this.getCustomer()
    this.reloadCart()
  }

  next() {
    this.$store.commit('customer_current', 1)
    this.getCustomer()
    this.reloadCart()
  }

  reloadCart() {
    const id: number = this.$store.state.customers.data[this.$store.state.customers.current].id
    this.tabs_cart.badge = this.$store.state.carts.current_customer_map.hasOwnProperty(id)
    if (this.tabs_cart.badge) {
      const cart: Order = this.$store.state.carts.current_customer_map[id]
      this.tabs_cart.badge_number = cart.items.length
    }
  }

  async getCustomer() {
    if (this.$store.state.customers.data) {
      this.customer = this.$store.state.customers.data[this.$store.state.customers.current]
      const id: number = this.$store.state.customers.data[this.$store.state.customers.current].id
      this.tabs_info.isLoad = true

      this.customer = await Customer.prototype.load<Customer>(id)


      this.getStat()


      this.tabs_info.isLoad = false


      // let sale1 = new User()
      // sale1.department = 'PJ'
      // sale1.nickname = 'น้องบาส'
      // sale1.picture = 'https://picsum.photos/120/120?image=120'
      //
      // let sale2 = new User()
      // sale2.department = 'TT'
      // sale2.nickname = 'พี่หนิง'
      // sale2.picture = 'https://picsum.photos/120/120?image=121'

      // this.customer.sales
      // state.users.id_map[user.id]

      this.refreshSale()


      // Helper.get(Helper.setting.customer.getResourceAPI.replace('{id}', id))
      //   .then<{ data: DataCustomer }>(({data}) => {
      //
      //     console.log(data.data)
      //     this.customer = data.data
      //     // this.items = data.data
      //     // console.log(this.items)
      //
      //     //this.$store.commit('customers_response', data)
      //     //this.reloadItem()
      //     this.tabs_info.isLoad = false
      //   })
    }
  }

  async searchLocation() {

    if (this.customer) {

      if (this.customer.gis_type == CustomerConst.GIS_TYPE_USER) {
        if (!confirm('พิกัด confirm จากเซล์แล้ว ถ้ากด ok จะลบที่เซล์ตั้งไว้')) {
          return
        }
      }

      const id: number = this.$store.state.customers.data[this.$store.state.customers.current].id
      this.google_isLoad = true

      this.customer = await Customer.prototype.search_location(id)

      this.google_isLoad = false


    }
  }

  async onConfirmLocation($event) {
    if (this.customer) {
      // this.customer.gis_is_confirm = $event

      this.confirmingLocation = true
      this.customer = await Customer.prototype.confirm_location(this.customer)
      this.confirmingLocation = false
    }
  }

  async editLocation() {
    this.$root.$emit('openLocationPicker', {
      option: {
        keyword: `${this.customer.name} ${this.customer.address} ${this.customer.district} ${this.customer.province} ${this.customer.zip_code}`
        , lat: this.customer.cache_lat, lng: this.customer.cache_lng,
      }, onApply: async (result) => {
        this.google_isLoad = true
        console.log('editLocation apply', result)

        this.customer.cache_lat = result.lat
        this.customer.cache_lng = result.lng

        this.customer = await Customer.prototype.save_location(this.customer)

        this.google_isLoad = false
      },
    })
  }

  async getStat() {
    if (this.$store.state.customers.data) {
      const customer: Customer = Object.setPrototypeOf(this.$store.state.customers.data[this.$store.state.customers.current], Customer.prototype)
      this.stat_isLoad = true
      console.log('gettingStat')
      const dataStat = await customer.loadStat()
      console.log('gettingStat', dataStat)
      this.graphData = dataStat
      console.log('graphData', this.graphData)
      //   {
      //   labels:
      //     ['กพ.', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', 'มีค.', ' ', ' ', ' ', ' ', ' '], values:
      //     [1, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
      // }


      this.stat_isLoad = false
    }
  }

  async getOrders() {
    if (this.$store.state.customers.data) {
      const customer: Customer = Object.setPrototypeOf(this.$store.state.customers.data[this.$store.state.customers.current], Customer.prototype)
      this.tabs_order.isLoad = true
      console.log('gettingOrders')
      const dataOrders = await customer.loadOrders()
      this.orders = dataOrders.data

      console.log('getOrders', this.orders)

      this.tabs_order.isLoad = false

      // Helper.get(Helper.setting.customer.getOrderAPI.replace('{id}', id))
      //   .then<{ data: DataOrdersArray }>(({data}) => {
      //
      //     console.log(data.data)
      //     this.orders = data.data
      //     // this.items = data.data
      //     // console.log(this.items)
      //
      //     //this.$store.commit('customers_response', data)
      //     //this.reloadItem()
      //     this.tabs_order.isLoad = false
      //   })
    }
  }

  async ToggleStar() {
    const current_star = this.customer.stars && this.customer.stars.length > 0

    const customer: Customer = Object.setPrototypeOf(this.customer, Customer.prototype)
    this.toggle_start_loading = true
    await customer.SetStar(!current_star)
    this.toggle_start_loading = false
    if (current_star) {
      customer.stars.pop()
    } else {
      customer.stars.push({id: 0})
    }
  }

  ApproveCustomer() {
    this.$root.$emit('onWarning', {message: 'อนุมัติได้จาก ERP เท่านั้น'})
  }

  async RejectCustomer() {
    if (this.customer.erp_remark1 == null || this.customer.erp_remark1 == '') {
      this.$root.$emit('onWarning', {message: 'กรุณาใส่หมายเหตุ'})
      return
    }


    try {
      this.isLoadSetStatus = true
      await Object.setPrototypeOf({
        id: this.customer.id,
        mode: 'fill',
        status: CustomerConst.STATUS_REJECTED,
      }, Customer.prototype).save()
      this.customer.status = CustomerConst.STATUS_REJECTED
      this.isLoadSetStatus = false
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }

  async setComment() {
    try {
      this.isLoadSetComment = true
      await Object.setPrototypeOf({
        id: this.customer.id,
        mode: 'fill',
        erp_remark1: this.customer.erp_remark1,
      }, Customer.prototype).save()
      this.isCommentChange = false
      this.isLoadSetComment = false
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }

  openOrder(option) {
    this.$root.$emit('openOrder', option)
  }

  setDateLastMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    // let tmpDateFrom = (new Date(Date.now() - tzoffset))
    var tmpDateFrom = new Date(Date.now())
    // tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 1)
    tmpDateFrom.setDate(0)
    this.dateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.getOrders()
  }

  setDateThisMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    var tmpDateFrom = new Date(Date.now())
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.dateTo = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)
    this.getOrders()
  }

  setDateToday() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    let tmpDateFrom = (new Date(Date.now() - tzoffset))

    this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)
    this.dateTo = tmpDateFrom.toISOString().substr(0, 10)
    this.getOrders()
  }

  private onTabInfo() {
    this.getCustomer()
  }

  private onTabOrder() {
    this.getOrders()
  }

  private onTabCheckin() {

  }

  private refreshSale() {
    this.sales = []
    console.log('customer sales', this.customer.sales)
    for (let index in this.customer.sales) {
      let sale = this.customer.sales[index]
      if (!sale || !sale.user_code) continue
      console.log('sales', sale)
      if (this.$store.state.users.code_map.hasOwnProperty(sale.user_code)) {
        let user = this.$store.state.users.code_map[sale.user_code]
        user.orderUser = sale
        this.sales.push(user)
      } else {
        let sale2 = new User()
        sale2.department = '??'
        sale2.nickname = sale.user_code
        sale2.picture = null
        sale2.orderUser = sale
        this.sales.push(sale2)
      }
    }
  }

  private openSales() {
    // debugger
    this.$root.$emit('openSales', {
      sales: this.sales, onApply: async (sales) => {
        this.customer.sales = sales
        this.refreshSale()

        try {
          await Object.setPrototypeOf({
            id: this.customer.id,
            sales: sales,
          }, Customer.prototype).save()
        } catch (e) {
          this.$root.$emit('onError', {error: e})
        }
      },
    })
  }

}

</script>
